var printButtons = document.getElementsByClassName('js-print');

// Provide print dialog when clicking element
// ------------------------------------------------------
function docPrinting(el) {

  // Open basic print dialog
  // ------------------------------------------------------
  function openDialog() {
    window.print();
  }

  // Event binding
  // ------------------------------------------------------
  function bindEvents() {
    el.addEventListener('click', openDialog);
  }

  // Kick off
  // ------------------------------------------------------
  bindEvents();
}

// Check of existence and loop over elements
Array.from(printButtons || []).forEach(docPrinting);
